module.exports = __webpack_public_path__ + "assets/img/0fca2b31660630989cb667665cab6b05.png";